import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import MoodUsersTable from './MoodUsersTable';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCompanyMoodUsers } from './companyMoodApi';

/**
 * Company Mood Tracking → Employees/Members list.
 * Every user of the current population appears (those who have never logged a
 * mood show dashes and sort last); a row opens their mood profile.
 */
const CMoodUsers = () => {
  const navigate = useNavigate();
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const fetcher = useCallback(
    (params) => fetchCompanyMoodUsers({ ...params, department }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Mood Tracking — {isB2BFansMode ? 'Members' : 'Employees'} | Shoorah</title>
      </Helmet>

      <p className="text-sm text-gray-500 dark:text-gray-400 mb-3">
        Your {isB2BFansMode ? 'members' : 'employees'} and how they use mood tracking. Open a user
        to see their mood profile — how often they log and how it trends, never what they wrote.
      </p>

      <MoodUsersTable
        fetcher={fetcher}
        onOpenUser={(rowData) => navigate(`/${slug}/mood/user?userId=${rowData?._id}`)}
        tableName="company_mood_users"
      />
    </div>
  );
};

export default CMoodUsers;
